import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

// 获取卡牌信息 http://wiki.xunlei.cn/pages/viewpage.action?pageId=108633906
export const getCardConfig = createAsyncThunk(
  'CardMixture/getCardConfig',
  async (p: any = {}, store: any) => {
    const resp = await http.post(
      '/live/gift/blind_box_card',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data
  }
)

// 合成卡牌  http://wiki.xunlei.cn/pages/viewpage.action?pageId=108634101 /live/gift/synthesis_blind_box_card
export const mixCard = createAsyncThunk(
  'CardMixture/mixCard',
  async (p: any = {}, store: any) => {
    const resp = await http.post(
      '/live/gift/synthesis_blind_box_card',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data
  }
)

interface CardItem {
  card_id: number
  card_cnt: number
  card_icon: string
}

export interface InitialStateType {
  reward_list?: Array<{
    id: number
    type: number // 1代表金币,2数量类型，3天数类型
    icon: string
    desc: string // 描述
    cnt: number // 奖励数量
    coins: number // 金币数
    material_list: Array<CardItem>
    max_cnt: number
  }>
  card_list?: Array<CardItem>
  gift_list?: Array<{
    icon: string
    desc: string
  }>
  mix_card?: {
    status?: number
    lack_card_list?: Array<CardItem>
    lack_gift_list?: Array<{
      id: number
      icon: string
    }>
    reward?: {
      id: number
      type: number
      icon: string
      desc: string
      cnt: number
      coins: number
    }
  }
}

const initialState: InitialStateType = {
  reward_list: [],
  card_list: [],
  gift_list: [],
  mix_card: {},
}

export const CardMixtureSlice = createSlice({
  name: 'CardMixture',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getCardConfig.fulfilled, (state, action) => {
      const {data} = action.payload
      Object.assign(state, data)
    })
    builder.addCase(mixCard.fulfilled, (state, action) => {
      const {data} = action.payload
      Object.assign(state?.mix_card, data)
    })
  },
})

export default CardMixtureSlice.reducer
